module.exports = __webpack_public_path__ + "static/media/robotoi4.51521a2a.woff2";